
import { mapActions } from "vuex";

export default {
  name: "CardStartupBannerFlat",
  props: {
    name: String,
    email: String,
    urlFacebook: String,
    urlLinkedin: String,
    urlWeb: String,
    hasOwner: Boolean,
    isLoggedIn: Boolean,
    logo: { type: String, default: "/images/default-image.png" },
    profileInfo: { type: Object, default: () => {} },
  },
  methods: {
    ...mapActions("app", ["setAuthDialogVisibility"]),
    claim() {
      return this.$emit("claim-startup");
    },
    onReport() {
      return this.$emit("report");
    },

    getUsername(item = {}) {
      const { first_name, first_name_kh, last_name, last_name_kh } = item;
      if (!this.$isKm()) return [first_name, last_name].join(" ");
      return [first_name_kh || first_name, last_name_kh || last_name].join(" ");
    },
  },
  computed: {
    founderInfo() {
      let template = `<span>
           ${this.$t("number_of_founders")}:
            <b>
            ${this.profileInfo.number_of_founder || this.$t("n_a")}
            </b>
          </span>
          <span>
            (${this.$t("female_founders")}:
            <b>
            ${this.profileInfo.number_of_female || this.$t("n_a")}
            </b>
            ${this.$t("tech_founders")}:
            <b>
            ${this.profileInfo.number_of_tech_founder || this.$t("n_a")}
            </b>
            )
          </span>
          `;
      return template;
    },
  },
};
